module.exports = __webpack_public_path__ + "static/media/header-img.db3edbf5.png";